'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import { PropsWithChildren, useRef } from 'react';
import { isDevelopmentEnvironment } from '@sola/shared-utils/misc.ts';
import { DataPrimer } from './primer';
const ReactQueryDevtools = dynamic(() => import('@tanstack/react-query-devtools').then(mod => ({
  default: mod.ReactQueryDevtools
})), {
  ssr: false
});
export type SupporterProviderProps = PropsWithChildren & {
  includeDevTools?: boolean;
};
export const SupporterProvider: React.FC<SupporterProviderProps> = ({
  children,
  includeDevTools = true
}) => {
  const queryClientRef = useRef<QueryClient | null>(null);
  if (!queryClientRef.current) {
    queryClientRef.current = new QueryClient({
      defaultOptions: {
        queries: {
          // Data will be considered fresh forever (until you invalidate/update it manually)
          staleTime: Infinity,
          retry: 1
        }
      }
    });
  }
  if (isDevelopmentEnvironment) {
    console.log('Rendering provider');
  }
  return <QueryClientProvider client={queryClientRef.current}>
      <DataPrimer />
      {children}
      {includeDevTools && isDevelopmentEnvironment && <ReactQueryDevtools />}
    </QueryClientProvider>;
};